module.exports = __webpack_public_path__ + "static/IMG_1753-d932045d4240d91245e898d43a35deea.png";